export default __webpack_public_path__ + "static/media/warning--accident-area--g2.20400c8d.png";